import Multiselect from 'vue-multiselect'
import Vue from 'vue';
Vue.component('multiselect', Multiselect)